/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ArticlesService } from '../../services/articles.service';
import { StorageProvider } from '../../services/storage.provider';
import { Subscription } from 'rxjs';

const KNE_ACCOUNTS = {
  '1': { user: '4924784907408@playbac.fr', password: 'Ka1YlNJT1Mfp' },
  '2': { user: '9185155488116@playbac.fr', password: 'Wc9HqxWrAE3w' },
  '3': { user: '6243510819326@playbac.fr', password: 'Vtx78nGzkWPt' },
  '4': { user: '5856822395412@playbac.fr', password: 'dyW0d7VB3r9Y' },
  '5': { user: '3836543314055@playbac.fr', password: 'bT384Qy7ok3k' },
  '6': { user: '8616637412127@playbac.fr', password: 'O0cLzW80sSXD' },
  '7': { user: '1230076062841@playbac.fr', password: '5msgHC7auPoz' },
  '8': { user: '8093227800135@playbac.fr', password: 'B98dNoQpDLSk' },
  '9': { user: '2807532019368@playbac.fr', password: 'cM3RYMoxeCBx' },
  '10': { user: '1539289312492@playbac.fr', password: 'u5TJOZZpxlOL' },
  '11': { user: '7143983046894@playbac.fr', password: 'QD6wladdLxZx' },
  '12': { user: '8575316860676@playbac.fr', password: '8JdN6HM5IW4P' },
  '13': { user: '5949517877741@playbac.fr', password: 'tS5WN78Eof9f' },
  '14': { user: '5066420804838@playbac.fr', password: 'wQL5v9jCpHvT' },
  '15': { user: '7555839361899@playbac.fr', password: '7vZ6PyGNvEDx' }
}

@Component({
  selector: 'app-kne-login',
  templateUrl: 'kne-login.html',
  styleUrls: ['kne-login.scss']
})
export class KneLoginPage implements OnInit {
  public spinner: boolean;
  public buttons: boolean;
  public error: string;
  public access_token: string;
  public kneSubscription: Subscription;

  constructor( private actRoute: ActivatedRoute, private router: Router, private service: ArticlesService, private storage: StorageProvider ) {}

  ngOnInit() {
    this.spinner = false;
    this.actRoute.queryParams.subscribe(params => {
      const { GUIDUser, GUIDRessource } = params;
      this.kneSubscription = this.service.getKneLogin({ GUIDUser, GUIDRessource }).subscribe({
        next:(response: any) => {
          if (response.connection) {
            this.service.loginToPlatformGet(KNE_ACCOUNTS[response.account].user, KNE_ACCOUNTS[response.account].password).subscribe(
              response => {
                this.spinner = true;
                this.access_token = response.access_token;
                this.storage.setStorage('access_token', this.access_token);
                this.goToProfiles();
              },
              error =>  this.connexionImposible()
            );
          } else {
            this.connexionImposible();
          }
        },
        error:(error) => this.connexionImposible()
      });
    });
  }

  ngOnDestroy() {
    if (this.kneSubscription) {
      this.kneSubscription.unsubscribe();
    }
  }

  public isLogin(): string {
    return 'login';
  }

  public goToHomePage() {
    this.router.navigate(['']);
  }

  public reconnect() {
    location.reload();
  }

  public goToProfiles() {
    this.router.navigate(['profiles'], { queryParams: { kne: true } });
  }

  private connexionImposible() {
    this.error = 'Connexion impossible';
    this.spinner = true;
  }
}
